import MediaManager from './MediaManager/MediaManager.vue';
import FormBuilder from './Forms/FormBuilder.vue';
import FormRenderer from './Forms/FormRenderer.vue';

import axios from 'axios'
import VueAxios from 'vue-axios'

const components = [MediaManager, FormBuilder, FormRenderer];

const VuePlugins = {
  install(Vue, options = {}) {
    // components
    for (const componentName in components) {
      const component = components[componentName]

      Vue.component(component.name, component)
    }

    Vue.use(VueAxios, axios);
  }
}
export default VuePlugins
